"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.exponentialBackoff = exports.getRetryObject = void 0;
const nodeHttpClient_1 = __importDefault(require("./nodeHttpClient"));
const getRetryObject = (retryOptions, logFunction) => {
    var _a;
    return ({
        limit: retryOptions.limit,
        calculateDelay: (0, exports.exponentialBackoff)((_a = retryOptions.baseDelay) !== null && _a !== void 0 ? _a : 50, typeof logFunction === "function" ? logFunction : () => {
        })
    });
};
exports.getRetryObject = getRetryObject;
const exponentialBackoff = (baseDelay, logFunction) => {
    return ({ attemptCount, retryOptions, error, computedValue }) => {
        // if computedValue is falsy, return 0 (this means any other reason for not retrying)
        if (!computedValue) {
            logFunction(`error=${error}; attemptCount=${attemptCount}; computedValue=${computedValue}. Not retrying`);
            return 0;
        }
        let delay = retryOptions.limit >= attemptCount ? baseDelay * Math.pow(2, attemptCount - 1) + Math.floor(Math.random() * baseDelay) : 0;
        if (delay > 0) {
            logFunction(`Retry #${attemptCount} on ${error}. delay=${delay}ms`);
        }
        else {
            logFunction("Not retrying again");
        }
        return delay;
    };
};
exports.exponentialBackoff = exponentialBackoff;
exports.default = nodeHttpClient_1.default;
//# sourceMappingURL=httpClient.js.map